import Plaintext from './Plaintext';
export default Plaintext;